import iconTranslate from '../../../weather/translations/weatherIconTranslations'

const getWeatherCode = (weatherCode: number, isNewLayout: boolean = false) => {
    if (isNewLayout) {
        return `/images/weather-new-icons/newWeatherSvgs/${weatherCode}.svg`
    }
    return `/images/weather/${iconTranslate(weatherCode)}.svg`
}

export default getWeatherCode